import React, { useState } from "react";
import moment from "moment";
import { useApi } from "../../utils/api";
import { useAuth } from "../../utils/auth";
import {
  Grid2,
  Typography,
  Card,
  Button,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
import activity from "./assets/activity.png";
import autoReview from "./assets/auto-review.png";
import editWorkout from "./assets/edit-workout.png";
import videoLibrary from "./assets/video-library.png";
import chat from "./assets/chat.png";
import appComments from "./assets/app-comments.png";
import appHistory from "./assets/app-history.png";
import appWorkout from "./assets/app-workout.png";
import appWorkouts from "./assets/app-workouts.png";

const CoachSignUpLanding = () => {
  const { createUser } = useApi();
  const { login } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleCreateCoachAccount = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    // Validate passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      setIsLoading(false);
      return;
    }

    // Validate password length
    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      setIsLoading(false);
      return;
    }

    try {
      const response = await createUser({
        name,
        email,
        password,
        isCoach: true,
        createdDate: moment().unix(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (typeof window.gtag === "function") {
        window.gtag("event", "coach_sign_up");
      }

      // Log the user in after successful account creation
      await login(email, password);
      window.location.href = "/clients";
    } catch (err) {
      console.error("Error creating coach account:", err);
      setError("Failed to create account. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid2 container justifyContent="center" sx={{ m: 4 }}>
      <Grid2 item lg={12} sm={12} sx={{ textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 4 }}>
          Trainer App
        </Typography>
        <Card sx={{ p: 3, maxWidth: 500, mx: "auto", mt: 4 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Get Started
          </Typography>
          <form onSubmit={handleCreateCoachAccount}>
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              label="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <TextField
              sx={{ mb: 2 }}
              fullWidth
              label="Confirm Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            {error && (
              <Typography color="error" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={isLoading}
              sx={{ mt: 2 }}
            >
              {isLoading ? (
                <CircularProgress size={24} />
              ) : (
                "Create Coach Account"
              )}
            </Button>
          </form>
        </Card>
      </Grid2>
    </Grid2>
  );
};

export default CoachSignUpLanding;
